/* Promoción NFL Freshbox 2026 — templates/page.promo-nfl.liquid
   Reloj de juego (countdown con estados), línea de tiempo y animaciones.
   Fechas vienen de data-* en .nfl-page con offset -06:00 (CDMX, sin horario de verano). */
(function () {
  var root = document.querySelector('.nfl-page');
  if (!root) return;

  var T = {
    start: Date.parse(root.getAttribute('data-start')),
    close: Date.parse(root.getAttribute('data-close')),
    draw: Date.parse(root.getAttribute('data-draw'))
  };

  var STATES = {
    pre: {
      status: 'Muy pronto',
      label: 'La promoción arranca en',
      note: 'Inicio: 12 de octubre de 2026 (hora CDMX)',
      target: T.start
    },
    live: {
      status: 'Promoción activa',
      label: 'La promoción cierra en',
      note: 'Cierre: 19 de noviembre de 2026, 11:59 p. m. (hora CDMX)',
      target: T.close
    },
    closed: {
      status: 'Participaciones cerradas',
      label: 'El sorteo es en',
      note: 'Sorteo: 20 de noviembre de 2026, 1:00 p. m. (hora CDMX)',
      target: T.draw
    },
    done: {
      status: 'Sorteo realizado',
      label: 'Gracias por participar',
      note: '',
      target: null
    }
  };

  function stateAt(now) {
    if (now < T.start) return 'pre';
    if (now <= T.close) return 'live';
    if (now < T.draw) return 'closed';
    return 'done';
  }

  /* ---------- Reloj ---------- */
  var clock = root.querySelector('[data-nfl-clock]');
  var el = clock ? {
    status: clock.querySelector('[data-nfl-status]'),
    label: clock.querySelector('[data-nfl-label]'),
    note: clock.querySelector('[data-nfl-note]'),
    digits: clock.querySelector('[data-nfl-digits]'),
    final: clock.querySelector('[data-nfl-final]'),
    d: clock.querySelector('[data-nfl-d]'),
    h: clock.querySelector('[data-nfl-h]'),
    m: clock.querySelector('[data-nfl-m]'),
    s: clock.querySelector('[data-nfl-s]')
  } : null;
  var current = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function render(now) {
    var key = stateAt(now);
    if (key !== current) {
      current = key;
      root.setAttribute('data-state', key);
      if (el) {
        var st = STATES[key];
        el.status.textContent = st.status;
        el.label.textContent = st.label;
        el.note.textContent = st.note;
        el.note.hidden = !st.note;
        el.digits.hidden = key === 'done';
        el.final.hidden = key !== 'done';
      }
      updateDrive(now);
    }
    if (!el || key === 'done') return;
    var diff = Math.max(0, STATES[key].target - now);
    el.d.textContent = pad(Math.floor(diff / 86400000));
    el.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    el.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
    el.s.textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  /* ---------- Línea de tiempo (drive) ----------
     El balón avanza por tramos entre los eventos: su posición se interpola
     entre los puntos reales de cada evento, así queda alineado en móvil
     (vertical) y escritorio (horizontal). */
  var drive = root.querySelector('[data-nfl-drive]');
  var events = drive ? Array.prototype.slice.call(drive.querySelectorAll('[data-at]')) : [];
  var track = drive ? drive.querySelector('.nfl-drive__track') : null;

  function updateDrive(now) {
    if (!drive || !track || !events.length) return;
    now = now || Date.now();
    var horizontal = track.offsetWidth > track.offsetHeight;
    var trackRect = track.getBoundingClientRect();
    var len = horizontal ? trackRect.width : trackRect.height;
    if (!len) return;
    var pts = events.map(function (li) {
      var r = li.getBoundingClientRect();
      var pos = horizontal ? (r.left - trackRect.left + 9) : (r.top - trackRect.top + 15);
      return { t: Date.parse(li.getAttribute('data-at')), p: Math.min(1, Math.max(0, pos / len)) };
    });
    var progress = 0;
    events.forEach(function (li, i) { li.classList.toggle('is-past', now >= pts[i].t); });
    if (now >= pts[pts.length - 1].t) {
      progress = pts[pts.length - 1].p;
    } else if (now > pts[0].t) {
      for (var i = 0; i < pts.length - 1; i++) {
        if (now >= pts[i].t && now < pts[i + 1].t) {
          var f = (now - pts[i].t) / (pts[i + 1].t - pts[i].t);
          progress = pts[i].p + f * (pts[i + 1].p - pts[i].p);
          break;
        }
      }
    } else {
      progress = pts[0].p;
    }
    drive.style.setProperty('--progress', progress.toFixed(4));
  }

  render(Date.now());
  setInterval(function () { render(Date.now()); }, 1000);
  setInterval(function () { updateDrive(); }, 60000);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { updateDrive(); }, 150);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { updateDrive(); });

  /* ---------- Bases: abrir / cerrar todas ---------- */
  var toggle = root.querySelector('[data-nfl-expand]');
  if (toggle) {
    var items = root.querySelectorAll('.nfl-acc__item');
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-pressed') !== 'true';
      Array.prototype.forEach.call(items, function (d) { d.open = open; });
      toggle.setAttribute('aria-pressed', String(open));
      toggle.textContent = open ? 'Cerrar todas' : 'Abrir todas';
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var reveal = root.querySelectorAll('[data-reveal]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduce) {
    root.classList.add('nfl-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(reveal, function (n, i) {
      n.style.transitionDelay = ((i % 3) * 80) + 'ms';
      io.observe(n);
    });
  }
})();
